var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.633,
    height: 16.633,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#447df7}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 2.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M11.881 85.333H1.782A1.782 1.782 0 0 0 0 87.115v10.1A1.782 1.782 0 0 0 1.782 99h10.1a1.782 1.782 0 0 0 1.782-1.782v-10.1a1.782 1.782 0 0 0-1.783-1.785zm.594 11.881a.594.594 0 0 1-.594.594H1.782a.594.594 0 0 1-.594-.594v-10.1a.594.594 0 0 1 .594-.594h10.1a.594.594 0 0 1 .594.594z",
    transform: "translate(0 -85.333)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(2.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M80.742 0H70.049a1.782 1.782 0 0 0-1.782 1.782.594.594 0 1 0 1.188 0 .594.594 0 0 1 .594-.594h10.693a.594.594 0 0 1 .594.594v10.693a.594.594 0 0 1-.594.594.594.594 0 0 0 0 1.188 1.782 1.782 0 0 0 1.782-1.782V1.782A1.782 1.782 0 0 0 80.742 0z",
    transform: "translate(-68.267)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.6691caa6d3d08ce96e550749c79b85f9.svg";
export { ForwardRef as ReactComponent };